import { render, staticRenderFns } from "./ShopDashboard.vue?vue&type=template&id=6135e7fa&scoped=true"
import script from "./ShopDashboard.vue?vue&type=script&lang=js"
export * from "./ShopDashboard.vue?vue&type=script&lang=js"
import style0 from "./ShopDashboard.vue?vue&type=style&index=0&id=6135e7fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6135e7fa",
  null
  
)

export default component.exports